import React from "react"
import EmailInput from "../FormElements/EmailInput"
import FormSection from "../FormElements/FormSection"
import FormSubmit from "../FormElements/FormSubmit"
import FormFooterLink from "../FormElements/FormFooterLink"
import SuccessCheckmark from "../FormElements/SuccessCheckmark"

export default class ForgotPassword extends React.Component {
	
	constructor(props) {
		super(props);

		this.state = {
			error: null,
			loading: false,
			success: false,
			email_address: '',
		}

		this.onChange = this.onChange.bind(this)
		this.onSubmit = this.onSubmit.bind(this)
	}

	render() {
		return (
			<div className="ForgotPassword">
				<form className="FormElements" onSubmit={this.onSubmit}>
					{this.state.error && <div className="alert alert-danger" dangerouslySetInnerHTML={{__html: I18n.t(this.state.error, {login_path: this.props.sign_in_path})}}></div>}
					<h1>Forgot your password?</h1>
					{
						this.state.success
						?
						this.renderSuccess()
						:
						this.renderForm()
					}
					{this.state.loading ? <div className="loadingOverlay"><div className="spinner"></div></div> : null}
				</form>
				<FormFooterLink path={this.props.sign_in_path} text='Return to Sign In' />
			</div>
		);
	}

	renderSuccess() {
		return (
			<div>
				<div className="FormInstructions">Check your inbox for a link to reset your password.</div>
				<SuccessCheckmark />
			</div>
		)
	}

	renderForm() {
		return (
			<div>
				<div className="FormInstructions">You will receive an email with a link to reset your password.</div>
				<FormSection>
					<EmailInput placeholder="Email address" name="email_address" value={this.state.email_address} onChange={this.onChange} />
				</FormSection>
				<FormSection>	
					<FormSubmit text="Send Reset Instructions" />
				</FormSection>			
			</div>
		);
	}

	/**
	* Change handlers
	*/

	onChange(e) {
		var { state } = this;
		state[e.target.name] = e.target.value;
		this.setState(state);
	}

	onSubmit(e) {
		var self = this;

		e.preventDefault()
		e.stopPropagation()

		this.setState({loading: true});

    $.ajax({
      type: 'POST',
      url: this.props.reset_password_token_path,
      data: {
      	principal: this.state.email_address
      }
    }).done(function (data) {	
    	// console.log('reset_password_token_path done', data)
    	if (data && data.error) {
    		self.setState({loading: false, error: data.error, success: false})
    	} else {
    		self.setState({loading: false, error: null, success: true})
    	}
    });	
	}

}